import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
};

const FactoryHero = () => (
  <section className="relative min-h-screen flex items-end overflow-hidden bg-black">
    {/* Full-bleed product footage */}
    <video
      src="/videos/hero-loop.mp4"
      autoPlay
      muted
      loop
      playsInline
      className="absolute inset-0 w-full h-full object-cover opacity-40"
    />
    <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/30 to-black"></div>

    <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full pb-24 pt-40">
      <div className="font-mono text-xs sm:text-sm tracking-[0.3em] uppercase text-emerald-400 mb-7">
        The Factory Agent
      </div>
      <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-[6.5rem] font-bold tracking-tight text-white leading-[0.98] mb-8 max-w-5xl">
        One prompt
        <br />
        becomes a factory.
      </h1>
      <p className="text-lg sm:text-xl text-gray-300 max-w-2xl leading-relaxed mb-10">
        Describe your line in plain language. Thirty minutes later you have a
        first draft of the whole factory — layout, line balance, shift
        schedule, work instructions, robot programs — proven against physics
        before your floor ever sees it.
      </p>
      <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
        <Button
          onClick={() => scrollTo('cta')}
          className="bg-emerald-600 hover:bg-emerald-500 text-white px-8 py-6 text-lg font-semibold transition-colors duration-200 group"
        >
          Book a demo
          <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform duration-300" size={18} />
        </Button>
        <Button
          onClick={() => scrollTo('demo')}
          variant="outline"
          className="border-2 border-white/25 text-white hover:bg-white/10 hover:border-white/40 px-8 py-6 text-lg font-semibold transition-colors duration-200"
        >
          Watch it work
        </Button>
      </div>
    </div>
  </section>
);

export default FactoryHero;
